export enum FacilityStatus {
    DECOMMISSIONED = 'decommissioned',
    DISUSED = 'disused',
    FUNCTIONAL = 'functional',
    NOT_REGULATED = 'notRegulated'
}